import { motion } from "framer-motion";
import { useI18n } from "@/i18n";

export function CtaBar() {
  const { t } = useI18n();

  return (
    <motion.div
      initial={{ y: 80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1, duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="fixed bottom-0 inset-x-0 z-40"
    >
      <div className="bg-white/90 backdrop-blur-xl border-t border-surface-2 shadow-cta safe-bottom">
        <div className="max-w-2xl mx-auto flex gap-3 px-5 py-3">
          <a
            href="https://price.kimonorentalann.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-surface-1 text-sm font-semibold text-ink-0 transition-all hover:bg-surface-2 active:scale-[0.97]"
          >
            <svg className="w-4 h-4 text-ink-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {t.cta.checkPricing}
          </a>
          <a
            href="https://experience.kimonorentalann.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-kra text-sm font-semibold text-white transition-all hover:bg-kra-dark active:scale-[0.97] shadow-soft"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008H15.75v-.008zm0 2.25h.008v.008H15.75V13.5zM15.75 18v-2.25m0 4.5v-2.25" />
            </svg>
            {t.cta.calculateCost}
          </a>
        </div>
      </div>
    </motion.div>
  );
}
